module.exports = __webpack_public_path__ + "img/teal-dot.2afbe1bd.svg";